// extracted by mini-css-extract-plugin
export default {"jsonToggleWrapper":"PolicyDetailsFrame_jsonToggleWrapper__4YQmj","headless":"PolicyDetailsFrame_headless__1+ELq"};